module.exports = __webpack_public_path__ + "img/icon-check-circle.68eee520.svg";